var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "page-title" }, [
        _c("span", [_vm._v(_vm._s(_vm.title))])
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "300px"
          }
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.translateWords.ProductName,
                prop: "ProductName"
              }
            },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.ruleForm.ProductName,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "ProductName", $$v)
                  },
                  expression: "ruleForm.ProductName"
                }
              }),
              _vm._v(" "),
              _vm.showwpbutton
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.showwptable }
                    },
                    [_vm._v("引用网片")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.translateWords.ProductCode,
                prop: "ProductCode"
              }
            },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.ruleForm.ProductCode,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "ProductCode", $$v)
                  },
                  expression: "ruleForm.ProductCode"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          false
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.translateWords.ModelType,
                    prop: "ModelType"
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.ruleForm.ModelType,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "ModelType", $$v)
                      },
                      expression: "ruleForm.ModelType"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.translateWords.ProductType,
                prop: "ProductType"
              }
            },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.ruleForm.ProductType,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "ProductType", $$v)
                  },
                  expression: "ruleForm.ProductType"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.translateWords.SumStorage,
                prop: "SumStorage"
              }
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.translateWords.inputNumber,
                  disabled: ""
                },
                model: {
                  value: _vm.ruleForm.SumStorage,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "SumStorage", _vm._n($$v))
                  },
                  expression: "ruleForm.SumStorage"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.Type == "edit"
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.translateWords.CanBeUseStorage,
                    prop: "CanBeUseStorage"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.translateWords.inputNumber },
                    model: {
                      value: _vm.ruleForm.CanBeUseStorage,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "CanBeUseStorage", _vm._n($$v))
                      },
                      expression: "ruleForm.CanBeUseStorage"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false"
                }
              ],
              attrs: {
                label: _vm.translateWords.SupplierCode,
                prop: "SupplierCode"
              }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.SupplierCode,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "SupplierCode", $$v)
                  },
                  expression: "ruleForm.SupplierCode"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.translateWords.NewOrOld, prop: "NewOrOld" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "400px" },
                  attrs: {
                    placeholder: _vm.translateWords.select,
                    filterable: ""
                  },
                  model: {
                    value: _vm.ruleForm.NewOrOld,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "NewOrOld", $$v)
                    },
                    expression: "ruleForm.NewOrOld"
                  }
                },
                _vm._l(_vm.Options.NewOrOld, function(el) {
                  return _c("el-option", {
                    key: String(el.Code),
                    attrs: { label: el.Name, value: String(el.Code) }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.translateWords.room, prop: "PositionId" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "400px" },
                  attrs: {
                    placeholder: _vm.translateWords.select,
                    filterable: ""
                  },
                  on: {
                    change: function($event) {
                      return _vm.selectvalue(
                        _vm.ruleForm.PositionId,
                        "PositionId"
                      )
                    }
                  },
                  model: {
                    value: _vm.ruleForm.PositionId,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "PositionId", $$v)
                    },
                    expression: "ruleForm.PositionId"
                  }
                },
                _vm._l(_vm.x_PositionIdoptions, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.translateWords.RackId, prop: "RackId" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "400px" },
                  attrs: {
                    placeholder: _vm.translateWords.select,
                    filterable: ""
                  },
                  on: {
                    change: function($event) {
                      return _vm.selectvalue(_vm.ruleForm.RackId, "RackId")
                    }
                  },
                  model: {
                    value: _vm.ruleForm.RackId,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "RackId", $$v)
                    },
                    expression: "ruleForm.RackId"
                  }
                },
                _vm._l(_vm.RackIdoptions, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.translateWords.Status, prop: "Status" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "400px" },
                  attrs: {
                    placeholder: _vm.translateWords.select,
                    filterable: ""
                  },
                  model: {
                    value: _vm.ruleForm.Status,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "Status", $$v)
                    },
                    expression: "ruleForm.Status"
                  }
                },
                _vm._l(_vm.Statusoptions, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.translateWords.IsBig, prop: "IsBig" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "400px" },
                  attrs: { placeholder: _vm.translateWords.select },
                  model: {
                    value: _vm.ruleForm.IsBig,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "IsBig", $$v)
                    },
                    expression: "ruleForm.IsBig"
                  }
                },
                _vm._l(_vm.Options.IsBig, function(el) {
                  return _c("el-option", {
                    key: String(el.Code),
                    attrs: { label: el.Name, value: String(el.Code) }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.translateWords.ImgType, prop: "ImgType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "400px" },
                  attrs: { placeholder: _vm.translateWords.select },
                  model: {
                    value: _vm.ruleForm.ImgType,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "ImgType", $$v)
                    },
                    expression: "ruleForm.ImgType"
                  }
                },
                _vm._l(_vm.Options.ImgType, function(el) {
                  return _c("el-option", {
                    key: String(el.Code),
                    attrs: { label: el.Name, value: String(el.Code) }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.translateWords.IsRequestByProductCenter,
                prop: "IsRequestByProductCenter"
              }
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "400px" },
                  attrs: { placeholder: _vm.translateWords.select },
                  model: {
                    value: _vm.ruleForm.IsRequestByProductCenter,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "IsRequestByProductCenter", $$v)
                    },
                    expression: "ruleForm.IsRequestByProductCenter"
                  }
                },
                _vm._l(_vm.Options.IsOrNot, function(el) {
                  return _c("el-option", {
                    key: String(el.Code),
                    attrs: { label: el.Name, value: String(el.Code) }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.translateWords.IsRequestByMultimedia,
                prop: "IsRequestByMultimedia"
              }
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "400px" },
                  attrs: { placeholder: _vm.translateWords.select },
                  model: {
                    value: _vm.ruleForm.IsRequestByMultimedia,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "IsRequestByMultimedia", $$v)
                    },
                    expression: "ruleForm.IsRequestByMultimedia"
                  }
                },
                _vm._l(_vm.Options.IsOrNot, function(el) {
                  return _c("el-option", {
                    key: String(el.Code),
                    attrs: { label: el.Name, value: String(el.Code) }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "400px" },
              attrs: {
                label: _vm.translateWords.ExpectedShipmentDateTime,
                prop: "ExpectedShipmentDateTime"
              }
            },
            [
              _c("el-date-picker", {
                attrs: {
                  format: "yyyy-MM-dd",
                  "format-value": "yyyy-MM-dd",
                  type: "date",
                  placeholder: "选择日期"
                },
                model: {
                  value: _vm.ruleForm.ExpectedShipmentDateTime,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "ExpectedShipmentDateTime", $$v)
                  },
                  expression: "ruleForm.ExpectedShipmentDateTime"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo",
                  attrs: {
                    action: "",
                    drag: "",
                    "on-preview": _vm.handlePreview,
                    "before-remove": _vm.beforeRemove,
                    "file-list": _vm.fileList,
                    "list-type": "picture",
                    "show-file-list": true,
                    "before-upload": _vm.beforeupload
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.translateWords.uploadTip) +
                        "\n          "
                    ),
                    _c("em", [_vm._v(_vm._s(_vm.translateWords.clickUpload))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip"
                    },
                    [_vm._v(_vm._s(_vm.translateWords.loadTip))]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.translateWords.Remark, prop: "Remark" } },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 2, placeholder: "" },
                model: {
                  value: _vm.ruleForm.Remark,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "Remark", $$v)
                  },
                  expression: "ruleForm.Remark"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticStyle: { float: "left" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("ruleForm")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.translateWords.save))]
              ),
              _vm._v(" "),
              _vm.env == "unico"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.resetForm("ruleForm")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.translateWords.reset))]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c5a31c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c5a31c5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditSampleFromAGBS.vue
// module id = null
// module chunks = 